import classNames from "classnames";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  date: string;
  disabled: boolean;
  textColor: string;
};

export const DateCell: FC<Props> = ({ date, disabled, textColor }) => {
  return (
    <div
      style={{ color: textColor }}
      className={classNames(styles.root, { [styles.disabled]: disabled })}
    >
      {date}
    </div>
  );
};
